import React from 'react';
import {Button, Image} from 'antd-mobile';
import SportSwiperCard, {SportsItem} from './swiper-card';

interface SportFloorProps {
  icon: string;
  title: string;
  hasLink?: boolean;
  hasLiveIcon?: boolean;
  sportsList: SportsItem[];
  isSport?: boolean;
  defaultSportIcon?: string;
  onLinkClick?: () => void;
}

const PreIcon = () => {
  return (
    <Button className="bg-[var(--live-bg)] text-white rounded-[0.325rem] text-xs w-[2.5rem] h-[1.2rem] font-size-10 flex items-center justify-center">
      Live
    </Button>
  );
};

const SportFloor = ({
  icon,
  title,
  hasLink,
  hasLiveIcon,
  isSport,
  sportsList,
  defaultSportIcon,
  onLinkClick,
}: SportFloorProps) => {
  return (
    <div className="flex flex-col">
      <div
        className="h-10 flex flex-row items-center justify-between px-3 bg-full"
        style={{
          backgroundImage: `url(${require('@assets/imgs/home/home-floor-title-bg.webp')})`,
        }}>
        <div className="flex flex-row gap-2 items-center">
          <Image src={icon} className="size-8" />
          <span
            onClick={() => hasLink && onLinkClick?.()}
            className="text-sm font-bold text-t1">
            {title}
          </span>
          {hasLiveIcon && <PreIcon />}
        </div>
        {hasLink && (
          <div onClick={onLinkClick} className="text-c1 text-xs font-bold">
            All
          </div>
        )}
      </div>
      <div className="w-full pb-3">
        <div className="flex flex-row gap-2 items-center overflow-x-auto hide-scrollbar pl-2 pr-2">
          {sportsList?.map((item, index) => (
            <SportSwiperCard
              key={index}
              item={item}
              isLive={item.isLive}
              isSport={isSport}
              isMix={true}
              icon={defaultSportIcon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SportFloor;
